import Colors from "@src/constants/Colors";
import { FC } from "react";

interface BackArrowTypes {
  color?: string;
  height?: string;
  width?: string;
  strokeWidth?: string;
}

const BackArrow: FC<BackArrowTypes> = ({
  color,
  width,
  height,
  strokeWidth,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 13L1 7L7 1"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

BackArrow.defaultProps = {
  color: Colors.primary,
  width: "8",
  height: "14",
  strokeWidth: "2",
};

export default BackArrow;
